import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import TimeBox from './TimeBox'
import { NewDropoffOpenCloseTime } from '../../../../core/domain/models/NewDropoff'
import closeIcon from '../../../../assets/icons/closeIcon.svg'

export interface IOpenCloseEntryProps {
    entry: NewDropoffOpenCloseTime
    onUpdate: (entry: NewDropoffOpenCloseTime) => void
    onDelete: () => void
    hasError: boolean
}

const OpenCloseEntry: React.FC<IOpenCloseEntryProps> = ({
    entry,
    onUpdate,
    onDelete,
    hasError
}) => {

    const intl = useIntl()
    const onStartTimeChange = ((time: string) => {
        onUpdate({
            ...entry,
            openTime: time
        })
    })

    const onEndTimeChange = ((time: string) => {
        onUpdate({
            ...entry,
            closeTime: time
        })
    })

    return (
        <OpenCloseEntryContainer>
            <TimeBox 
                title={intl.formatMessage({id: 'SubmitDropoff.contact.open.time'})} 
                onChange={onStartTimeChange}
                defaultValue={entry.openTime}
                hasError={hasError}
            />
            <TimeBox
                title={intl.formatMessage({id: 'SubmitDropoff.contact.close.time'})} 
                onChange={onEndTimeChange}
                defaultValue={entry.closeTime}
                hasError={hasError}
            />
            <RemoveButton onClick={onDelete}><img src={closeIcon} alt="delete entry"/></RemoveButton>
        </OpenCloseEntryContainer>
    )
}

const OpenCloseEntryContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;

    div {
        margin-right: 8px;
    }
`

const RemoveButton = styled.button`
    background: ${({ theme }) => theme.color.buttonGrey};
    width: 34px !important;
    height: 34px !important;
    border-radius: 17px;
    padding-top: 4px;
    margin-top: 5px;
    cursor: pointer;
`

export default OpenCloseEntry
